import React from "react";
import PropTypes from "prop-types";
import classes from "./playcard.module.css";
import { TennisSport, CardSelectedMarker } from "../../constant/imagePath";
/**
 * Primary UI component for user interaction
 */
export const PlayCard = ({
  icon,
  title,
  value,
  customStyle,
  iconStyle,
  showSelection,
  selectedData,
  onClick,
  titleStyle,
  valueStyle,
  ...props
}) => {
  return (
    <div
      className={`${[classes.Container].join(" ")}`}
      {...props}
      style={customStyle}
      onClick={onClick}
    >
      <img
        src={icon}
        alt=""
        className={`${[classes.image].join(" ")}`}
        style={iconStyle}
      />
      <span
        className={`${[classes.title].join(" ")}`}
        style={{ ...titleStyle }}
      >
        {title}
        {showSelection && selectedData === title && (
          <img
            src={CardSelectedMarker}
            className={`${[classes.selectImage].join(" ")}`}
          />
        )}
      </span>
      {value && (
        <span style={valueStyle} className={`${[classes.value].join(" ")}`}>
          {value}
        </span>
      )}
    </div>
  );
};

PlayCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  customStyle: PropTypes.string,
  selectedData: PropTypes.string,
  onClick: PropTypes.func,
  showSelection: PropTypes.bool,
  titleStyle: PropTypes.object,
  valueStyle: PropTypes.object,
};

PlayCard.defaultProps = {
  icon: TennisSport,
  title: "Title",
  value: null,
  customStyle: {},
  selectedData: "",
  showSelection: false,
  onClick: undefined,
};
